/* eslint-disable eqeqeq */
import { useSelector } from "react-redux";

const useCommodities = () => {
  const { currentTrip } = useSelector((state) => state.trips);
  const { allCommodities } = useSelector((state) => state.rates);

  if (!allCommodities.length) return [];
  if (!currentTrip?.hubId) return [];

  const commodities = allCommodities
    ?.filter((c) => c.hubId == currentTrip?.hubId)
    .map((item) => ({
      key: item.id,
      value: item.name.toLowerCase(),
      hubId: item?.hubId,
    }));

  return commodities;
};

export default useCommodities;
